import { ProgressCircle } from 'shared';
import { ObjectValues } from 'types/common';

import { SPRINT_STATES } from 'features/sprint/config';

export const SprintInfoProgressCircle = ({
  status,
  successRate,
  weekIndex,
  weeksCount,
}: {
  status: ObjectValues<typeof SPRINT_STATES>;
  successRate: number;
  weekIndex: number;
  weeksCount: number;
}) => {
  const progressPercentage = (weekIndex / weeksCount) * 100;
  const sprintInfoContentMap = {
    [SPRINT_STATES.ACTIVE]: {
      text: `${weekIndex}/${weeksCount}`,
      color: 'blue',
    },
    [SPRINT_STATES.FINISHED]: {
      text: `${successRate || 0}%`,
      color: 'black',
    },
  };

  return (
    <ProgressCircle
      thickness="5px"
      valueText={sprintInfoContentMap[status]?.text}
      value={progressPercentage}
      colorPalette={sprintInfoContentMap[status]?.color || 'blue'}
    />
  );
};
